export * from './reset-pass.component';
